// Auto-generated by /app/scripts/gen_images.py
export const IMAGES = {
  "hero": "/images/hero_main.png",
  "featured": {
    "1": "/images/featured_1_gemini.png",
    "2": "/images/featured_2_coscientist.png",
    "3": "/images/featured_3_alphaevolve.png",
    "4": "/images/featured_4_clinician.png"
  },
  "domains": {
    "1": "/images/domain_1_life.png",
    "2": "/images/domain_2_earth.png",
    "3": "/images/domain_3_energy.png",
    "4": "/images/domain_4_algo.png"
  },
  "breakthroughs": {
    "1": "/images/bt_1_alphafold.png",
    "2": "/images/bt_2_alphaproof.png",
    "3": "/images/bt_3_graphcast.png",
    "4": "/images/bt_4_alphamissense.png",
    "5": "/images/bt_5_alphatensor.png"
  },
  "impact": {
    "1": "/images/impact_1_weather.png",
    "2": "/images/impact_2_meds.png",
    "3": "/images/impact_3_als.png",
    "4": "/images/impact_4_molecular.png"
  },
  "cta": "/images/cta_banner.png",
  "resources": {
    "1": "/images/res_1_alphafold.png",
    "2": "/images/res_2_alphagenome.png",
    "3": "/images/res_3_alphamissense.png",
    "4": "/images/res_4_alphaproteo.png"
  },
  "resourcesBySlug": {
    "alphafold": "/images/res_1_alphafold.png",
    "alphagenome": "/images/res_2_alphagenome.png",
    "alphamissense": "/images/res_3_alphamissense.png",
    "alphaproteo": "/images/res_4_alphaproteo.png",
    "graphcast": "/images/res_earth_1_graphcast.png",
    "weathernext": "/images/res_earth_2_weathernext.png",
    "alphaearth": "/images/res_earth_3_alphaearth.png",
    "coastalai": "/images/res_earth_4_coastalai.png",
    "gnome": "/images/res_energy_1_gnome.png",
    "fusionfold": "/images/res_energy_2_fusionfold.png",
    "batterynet": "/images/res_energy_3_batterynet.png",
    "crystalai": "/images/res_energy_4_crystalai.png",
    "alphatensor": "/images/res_algo_1_alphatensor.png",
    "alphaproof": "/images/res_algo_2_alphaproof.png",
    "alphacode": "/images/res_algo_3_alphacode.png",
    "alphadev": "/images/res_algo_4_alphadev.png"
  },
  "why": {
    "1": "/images/why_1.png",
    "2": "/images/why_2.png"
  }
};
export default IMAGES;
